import { useEffect } from 'react'

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

export default function CancelReservationModal({ open, onClose, onConfirm }: Props) {
  useEffect(() => {
    if (!open) return
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleEsc)
    document.body.style.overflow = 'hidden'
    return () => {
      window.removeEventListener('keydown', handleEsc)
      document.body.style.overflow = ''
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="cancel-reservation-title"
      className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-[12px] max-w-[321px] w-full min-h-min p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="cancel-reservation-title" className="text-[16px] font-medium text-center mt-2">
          予約キャンセル
        </h2>
        <div className="mt-[27px] mx-[20px] mb-[10px] text-center">
          <p className="text-[16px]">診療をキャンセルしますか？</p>
          <span className="text-[12px]">一度キャンセルすると再度予約の取り直しになります。</span>
          <br />
          <span className="text-[12px]">※開始2時間前からのキャンセルおよび無断キャンセルは、キャンセル料金［2,000円］が発生します。</span>
          <button
            type="button"
            onClick={onConfirm}
            className="text-[14px] block mt-[10px] mx-auto mb-[12px] text-center text-[#04aae4] bg-white border border-[#04aae4] rounded-[30px] px-0 py-[10px] w-full cursor-pointer"
          >
            診療予約のキャンセルを確定する
          </button>
          <button
            type="button"
            onClick={onClose}
            className="block border-none bg-transparent underline text-[#97979a] text-[12px] mt-[10px] mx-auto mb-[16px] text-center w-full"
          >
            診療を予約したまま確認画面へ戻る
          </button>
        </div>
      </div>
    </div>
  )
}
